// ─── src/utils/formatters.ts ──────────────────────────────────────────────────

export const formatDate = (iso?: string) =>
    iso
      ? new Intl.DateTimeFormat("en-GB", { dateStyle: "medium" }).format(
          new Date(iso)
        )
      : "—";
  
  export const capitalize = (s: string) =>
    s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  
  export const initials = (name: string) =>
    name
      .split(" ")
      .slice(0, 2)
      .map((n) => n[0]?.toUpperCase() ?? "")
      .join("");
  
  // Deterministic avatar colour from name string
  const AVATAR_PALETTE = [
    "bg-teal-600",
    "bg-indigo-600",
    "bg-purple-600",
    "bg-rose-600",
    "bg-amber-600",
    "bg-cyan-600",
    "bg-emerald-600",
    "bg-sky-600",
  ];
  
  export const avatarColor = (name: string): string => {
    const idx =
      name.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0) %
      AVATAR_PALETTE.length;
    return AVATAR_PALETTE[idx];
  };
  
  export const STATUS_BADGE: Record<string, string> = {
    student:      "bg-purple-500/20 text-purple-300 border border-purple-500/30",
    employed:     "bg-emerald-500/20 text-emerald-300 border border-emerald-500/30",
    freelancer:   "bg-yellow-500/20 text-yellow-300 border border-yellow-500/30",
    unemployed:   "bg-red-500/20 text-red-300 border border-red-500/30",
    entrepreneur: "bg-orange-500/20 text-orange-300 border border-orange-500/30",
  };
  
  export const defaultStatusBadge =
    "bg-gray-500/20 text-gray-300 border border-gray-500/30";